export default "https://cdn-static.gokick.com/assets/67048a8b985695a5a0d96903cfbe49422bf26f75/images/spearmint-flavor.4c44d265d2ca14e44f653db82c437465.png";